export default __webpack_public_path__ + "media/images/wp-login.png";